import { render } from "./ReadGalery.vue?vue&type=template&id=9ce3dac2&scoped=true"
import script from "./ReadGalery.vue?vue&type=script&lang=js"
export * from "./ReadGalery.vue?vue&type=script&lang=js"

import "./ReadGalery.vue?vue&type=style&index=0&id=9ce3dac2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce3dac2"]])

export default __exports__